import { render, staticRenderFns } from "./VCard.vue?vue&type=template&id=d6297128&scoped=true&"
import script from "./VCard.vue?vue&type=script&lang=js&"
export * from "./VCard.vue?vue&type=script&lang=js&"
import style0 from "./VCard.vue?vue&type=style&index=0&id=d6297128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6297128",
  null
  
)

export default component.exports